import React, { useState } from "react";
import {
  Button,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import { ExpandMore, ExpandLess } from "@mui/icons-material";

interface DropdownOption {
  label: string;
  value: string;
  icon?: React.ReactNode; // Icon is now optional
}

interface ButtonDropdownProps {
  label: string;
  options: DropdownOption[];
  onSelect: (value: string) => void;
  disabled?: boolean;
}

const ButtonDropdown: React.FC<ButtonDropdownProps> = ({
  label,
  options,
  onSelect,
  disabled = false,
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    if (disabled) return;
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSelect = (value: string) => {
    onSelect(value);
    handleClose();
  };

  return (
    <>
      <Button
        className="button-dropdown"
        variant={open ? "outlined" : "contained"}
        onClick={handleClick}
        endIcon={open ? <ExpandLess /> : <ExpandMore />}
        disableRipple // Removes the ripple effect
        disabled={disabled}
        style={{
          backgroundColor: open ? "#fff" : "#19303A",
          color: open ? "#19303A" : "#fff",
          textTransform: "capitalize",
          minWidth: "31px",
          fontSize: "16px",
          borderWidth: "1px",
          borderColor: "#19303A",
          borderRadius: "5px",
          opacity: disabled ? 0.5 : 1,
        }}
      >
        {label}
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        slotProps={{
          paper: {
            style: {
              border: "1px solid #19303A",
              borderRadius: "5px",
              marginTop: "8px",
              boxShadow: "rgba(0, 0, 0, 0.1) 0 4px 12px",
            },
          },
        }}
      >
        {options.map((option) => (
          <MenuItem
            key={option.value}
            onClick={() => handleSelect(option.value)}
            style={{
              padding: "8px 16px",
              color: "#59585B",
              minWidth: "113px",
            }}
          >
            {option.icon && (
              <ListItemIcon style={{ minWidth: "25px" }}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "13px",
                    height: "13px",
                    color: "#A3A8B4",
                  }}
                >
                  {option.icon}
                </div>
              </ListItemIcon>
            )}
            <ListItemText primary={option.label} />
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default ButtonDropdown;
